export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-background-200">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-10">
          <div className="md:col-span-4">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-full bg-primary-500 flex items-center justify-center">
                <i className="ri-planet-line text-sm text-background-50"></i>
              </div>
              <span className="font-heading text-lg text-background-50">
                星球漫画
              </span>
            </div>
            <p className="text-background-400 text-sm leading-relaxed mb-4">
              星球漫画是领先的免费漫画在线阅读平台，提供海量免费漫画资源，支持下拉式流畅阅读体验。涵盖热血、恋爱、玄幻、悬疑、搞笑等全品类题材，每日更新，免VIP追更全集，致力于为广大漫画爱好者提供最优质的免费在线漫画阅读服务。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 rounded-lg bg-background-800 hover:bg-primary-600 flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-lg bg-background-800 hover:bg-primary-600 flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-lg bg-background-800 hover:bg-primary-600 flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-bilibili-line text-sm"></i>
              </a>
            </div>
          </div>

          <div className="md:col-span-2">
            <h4 className="font-heading text-sm text-background-50 mb-4">快速导航</h4>
            <nav className="flex flex-col gap-2.5">
              <a href="#hero" className="text-background-400 hover:text-primary-400 text-sm transition-colors whitespace-nowrap cursor-pointer">首页</a>
              <a href="#index" className="text-background-400 hover:text-primary-400 text-sm transition-colors whitespace-nowrap cursor-pointer">热门专题</a>
              <a href="#ranking" className="text-background-400 hover:text-primary-400 text-sm transition-colors whitespace-nowrap cursor-pointer">人气排行</a>
              <a href="#updates" className="text-background-400 hover:text-primary-400 text-sm transition-colors whitespace-nowrap cursor-pointer">最新更新</a>
              <a href="#carousel" className="text-background-400 hover:text-primary-400 text-sm transition-colors whitespace-nowrap cursor-pointer">精选推荐</a>
            </nav>
          </div>

          <div className="md:col-span-2">
            <h4 className="font-heading text-sm text-background-50 mb-4">漫画分类</h4>
            <nav className="flex flex-col gap-2.5">
              <a href="#index" className="text-background-400 hover:text-primary-400 text-sm transition-colors whitespace-nowrap cursor-pointer">热血冒险</a>
              <a href="#index" className="text-background-400 hover:text-primary-400 text-sm transition-colors whitespace-nowrap cursor-pointer">玄幻修仙</a>
              <a href="#index" className="text-background-400 hover:text-primary-400 text-sm transition-colors whitespace-nowrap cursor-pointer">恋爱校园</a>
              <a href="#index" className="text-background-400 hover:text-primary-400 text-sm transition-colors whitespace-nowrap cursor-pointer">悬疑推理</a>
              <a href="#index" className="text-background-400 hover:text-primary-400 text-sm transition-colors whitespace-nowrap cursor-pointer">搞笑日常</a>
            </nav>
          </div>

          <div className="md:col-span-2">
            <h4 className="font-heading text-sm text-background-50 mb-4">帮助支持</h4>
            <nav className="flex flex-col gap-2.5">
              <a href="#faq" className="text-background-400 hover:text-primary-400 text-sm transition-colors whitespace-nowrap cursor-pointer">常见问题</a>
              <a href="#contact" className="text-background-400 hover:text-primary-400 text-sm transition-colors whitespace-nowrap cursor-pointer">联系我们</a>
              <a href="#about" className="text-background-400 hover:text-primary-400 text-sm transition-colors whitespace-nowrap cursor-pointer">关于我们</a>
              <a href="#features" className="text-background-400 hover:text-primary-400 text-sm transition-colors whitespace-nowrap cursor-pointer">平台优势</a>
              <a href="#media" className="text-background-400 hover:text-primary-400 text-sm transition-colors whitespace-nowrap cursor-pointer">精彩视频</a>
            </nav>
          </div>

          <div className="md:col-span-2">
            <h4 className="font-heading text-sm text-background-50 mb-4">合作伙伴</h4>
            <p className="text-background-500 text-xs leading-relaxed">
              诚邀优秀漫画平台、内容创作者及行业伙伴加入合作生态，共同推动漫画产业发展。合作咨询请通过联系我们板块取得联系。
            </p>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-800/60">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-background-500 text-xs">
              &copy; 2026 星球漫画 | 免费漫画全集在线免费阅读平台
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-background-500 hover:text-background-300 text-xs transition-colors whitespace-nowrap cursor-pointer">用户协议</a>
              <a href="#" className="text-background-500 hover:text-background-300 text-xs transition-colors whitespace-nowrap cursor-pointer">隐私政策</a>
              <a href="#" className="text-background-500 hover:text-background-300 text-xs transition-colors whitespace-nowrap cursor-pointer">版权声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}